import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { FormsModule } from "@angular/forms";
import { AppComponent } from "./app.component";
import {
  MonacoEditorModule,
  NgxMonacoEditorConfig,
} from "ngx-monaco-editor-v2";
import { HttpClientModule } from "@angular/common/http";
import * as $RefParser from "@apidevtools/json-schema-ref-parser";

function onMonacoLoad() {
  const monaco = (window as any).monaco;
  if (!monaco) return;
  $RefParser
    .dereference("/schemas/meta/oasis.json")
    .then((metaSchema) => {
      monaco.languages.json.jsonDefaults.setDiagnosticsOptions({
        validate: true,
        allowComments: false,
        enableSchemaRequest: true,
        schemas: [
          {
            uri: "https://form-schemas.careinsights.wellsky.io/schemas/meta/oasis.json",
            fileMatch: ["*"],
            schema: metaSchema,
            // schema: {
            //     type: 'object',
            //     properties: {
            //         q1: {
            //             enum: ['x1', 'x2']
            //         }
            //     }
            // }
          },
        ],
      });
    })
    .catch((err) => console.error("Failed to load JSON meta-schema", err));
}

const monacoConfig: NgxMonacoEditorConfig = {
  baseUrl: "assets/monaco",
  defaultOptions: { scrollBeyondLastLine: false, automaticLayout: true },
  onMonacoLoad,
};

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    FormsModule,
    HttpClientModule,
    MonacoEditorModule.forRoot(monacoConfig),
  ],
  providers: [],
  bootstrap: [AppComponent],
})
export class AppModule {}
